<template>
  <div class="print-box tem p-1">
    <table class="prtable prtable-center prtable-bordered">
      <tr>
        <td>Tên hàng</td>
        <td colspan="4" style="font-size: 13px;">
          <b v-if="manufacture.product">{{ manufacture.product.name }} </b>
          <!-- <span v-if="manufacture.productCustom != ''"><br>{{ manufacture.productCustom }}</span> -->
          <b v-if="manufacture.reason"><br />{{ manufacture.reason.name }}</b>
        </td>
      </tr>
      <tr>
        <td>Mã SP</td>
        <td colspan="4" style="font-size: 15px;">
          <b v-if="manufacture.product">{{ manufacture.product.code }}</b>
        </td>
      </tr>
      <tr>
        <td>Quy cách</td>
        <td colspan="2" style="font-size: 15px;">
          <b v-if="manufacture.productSpecify">{{ manufacture.productSpecify.name }}</b>
        </td>
        <td colspan="2" style="font-size: 15px;">mm</td>
        <!-- <td>{{ manufacture.length }} cm</td> -->
      </tr>
      <tr>
        <td>Chiều dài</td>
        <td colspan="2" style="font-size: 15px;">
          {{ manufacture.length }}
        </td>
        <td colspan="2" style="font-size: 15px;">cm</td>
      </tr>
      <tr>
        <td>Màu sắc</td>
        <td colspan="2" style="font-size: 15px;">
          <!-- <b v-if="manufacture.color">{{ manufacture.color.label }}</b> -->
          <b>{{ manufacture.colorText }}</b>
        </td>
        <td colspan="2" style="font-size: 15px;">{{ manufacture.colorCode1 }}</td>
      </tr>
      <tr>
        <td>Số lượng</td>
        <td colspan="2" style="font-size: 15px;">
          <!-- <b v-if="isOdd">
            <span v-if="quantityOdd">{{ quantityOdd }}</span>
            <span v-else>{{ Tem.slbichOdd }}</span>
          </b>
          <b v-else>{{ Tem.slbich }}</b> -->
          <b v-if="temInfo">{{ temInfo.quantity }}</b>
          <b v-else-if="isOdd">
            <span>{{ Tem.slbichOdd }}</span>
          </b>
          <b v-else>{{ Tem.slbich }}</b>
        </td>
        <td style="font-size: 15px;">
          <span v-if="temInfo.unit && temInfo.unit != ''">{{ temInfo.unit }}</span>
          <span v-else>{{ manufacture.unit }}</span>
        </td>
        <td style="font-size: 15px;">
          <span style="display: flex;align-items:center">
            <span style="width:100%">{{ $formatNumber(temInfo.slcbich) }}</span>
            <div style="width:100%">
              <span style="display:block; border-bottom:1px solid #000">C</span>
              <span>B</span>
            </div>
          </span>
        </td>
      </tr>
      <tr>
        <td>Số Lot</td>
        <td colspan="2" style="font-size: 15px;">
          <b>{{ manufacture.code }}</b>
        </td>

        <td colspan="2" style="font-size: 15px;">
          <span>
            {{ $formatNumberFixed(Number(temInfo.slcbich) * Number(temInfo.hesobich) + Number(temInfo.tlbich)) }}
          </span>
        </td>
      </tr>
      <tr>
        <td>QC</td>
        <td colspan="2" style="width:100px; font-size: 15px;">
          <span>{{ $formatNumber(Number(temInfo.hesobich)) }}</span>
        </td>
        <td colspan="2" style="font-size: 15px;">
          <span>
            {{ $formatNumberFixed(temInfo.tlbich) }}
          </span>
        </td>
      </tr>
      <tr v-if="temInfo">
        <td>Note</td>
        <td colspan="4" style="width:100px; font-size: 15px;">
          <!-- <base-input
              v-if="isEditNote"
              v-model="temInfo.note"
              placeholder="Ghi chú"
          ></base-input>
          <span v-else>{{ temInfo.note}}</span> -->
          <textarea v-if="isEditNote" placeholder="Ghi chú" v-model="temInfo.note" class="form-control"></textarea>
          <div v-else style="white-space: pre; text-align: left;" v-html="temInfo.note"></div>
        </td>
      </tr>
      <tr v-if="code">
        <td colspan="5">
          <barcode v-bind:value="code" height="40" width="1" fontSize="12">
            Lỗi render code
          </barcode>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import VueBarcode from 'vue-barcode';
export default {
  name: 'tem-bich-view',
  components: {
    barcode: VueBarcode
  },
  props: {
    manufacture: {},
    code: {},
    Tem: {},
    temInfo: {},
    quantityOdd: {},
    isOdd: {
      type: Boolean,
      default: false
    },
    isEditNote: {
      type: Boolean,
      default: false
    }
  }
};
</script>
